import React from 'react'
import OptionButtonPR from './optionButtonPR.js'

export default class QuestionScreenPR extends React.Component {

	render(){
		const {
			data, 
			handler,
			pvOptionsHash,
			lang,
			setPVAnswer
		} = this.props
		let questionText = data.questions[0].field.text
		return(
			<div className='questionContainerPR'>
				<div className='question'>{questionText}</div>
				<div className='optionsPR'>
					{Object.keys(pvOptionsHash).map(function(keyName, keyIndex) {
						let assetpath = lang.concat('/properties/')
						if(keyName === 'hobby' || keyName === 'pet' || keyName === 'relationship'){
							assetpath = lang.concat('/screen_5/')
						}
					  return(
							<OptionButtonPR
								key={keyIndex}
								name={keyIndex}
								handler={handler}
								icon={pvOptionsHash[keyName]}
								path={assetpath}
								setPVAnswer={setPVAnswer}
							/>
						)
					})}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/components/presentationReferral/subcomponents/questionScreenPR.js